import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpotlightValidatedCompanies = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-building2 lucide-building-2 w-5 h-5 text-[#5B5FED]",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 6h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 10h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 14h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 18h4" })
	]
});
export default SvgSpotlightValidatedCompanies;
